;(function () {
  'use strict'

  angular
    .module('contrast.settings.groups')
    .controller('EditGroupCtrl', EditGroupCtrl)

  function EditGroupCtrl(
    $scope,
    $controller,
    $q,
    $location,
    $routeParams,
    $translate,
    logger,
    csTemplates,
    dialogs,
    ErrorService,
    groupService,
    UserService,
    groupsApiConfig
  ) {
    'ngInject'

    var groupId
    var group
    var deleteGroupTemplateUrl

    var baseCtrl

    this.$onInit = function () {
      groupId = $routeParams.groupId
      group = undefined
      deleteGroupTemplateUrl = 'views/settings/group/template/delete.tpl.html'

      baseCtrl = $controller('BaseGroupCtrl', {
        $scope: $scope
      })
      baseCtrl.$onInit()

      angular.extend(this, baseCtrl)

      angular.extend($scope, {
        isEdit: true,
        validation: {
          unique: true,
          setName: true,
          pristine: false,
          exceptions: true
        },
        limit: 6
      })

      angular.extend($scope, {
        saveGroup: saveGroup,
        deleteGroup: deleteGroup,
        checkName: checkName
      })

      init()
    }

    function init() {
      $scope.loadPromise = $q.all([baseCtrl.init()]).then(function () {
        return _getGroup()
      })
    }

    function saveGroup() {
      $scope.saving = true
      var form
      if ($scope.editable) {
        form = groupService.createGroupCreationRequest($scope.group)
      } else {
        form = {
          name: group.name,
          users: [],
          scope: {
            app_scope: {
              role: group.app_role,
              onboard_role: group.onboard_role,
              exceptions: []
            }
          }
        }

        angular.forEach($scope.group.users, function (user) {
          form.users.push(user.uid)
        })
      }

      return groupsApiConfig.updateGroup(groupId, form).then(
        function (response) {
          $scope.saving = false
          logger.logSuccess(response.data.messages[0])
          $location.path(UserService.buildUrl('/settings/groups'))
        },
        function (response) {
          $scope.saving = false
          ErrorService.processError(response)
        }
      )
    }

    function checkName() {
      $scope.validation.pristine = true
      if (
        angular.isDefined($scope.group.name) &&
        $scope.group.name.length > 0
      ) {
        $scope.validation.setName = true
        groupsApiConfig.checkNameUpdate(groupId, $scope.group.name).then(
          function () {
            $scope.validation.unique = true
          },
          function () {
            $scope.validation.unique = false
          }
        )
      } else {
        $scope.validation.unique = true
        $scope.validation.setName = false
      }
    }

    function _getGroup() {
      return groupsApiConfig.getGroup(groupId).then(function (response) {
        group = response.data.group
        $scope.editable = !group.readonly
        $scope.group = groupService.createEditView(
          group,
          $scope.app_roles,
          $scope.users
        )
        baseCtrl.removeCurrentUser()
        baseCtrl._updateAvailableApps()
        _checkChildApplications()
      })
    }

    function _checkChildApplications() {
      var i = 0
      for (; i < $scope.group.exceptions.length; i++) {
        var hasChilds = _.some($scope.group.exceptions[i].apps, function (app) {
          return app.child
        })
        if (hasChilds) {
          return
        }
      }
    }

    function deleteGroup() {
      return csTemplates
        .loadAndInterpolate(deleteGroupTemplateUrl, { groupName: group.name })
        .then(
          function (interpolatedStr) {
            var transl = {
              title_groupSettings_deleteGroup: $translate.instant(
                'title_groupSettings_deleteGroup'
              ),
              action_delete: $translate.instant('action_delete'),
              action_cancel: $translate.instant('action_cancel')
            }

            dialogs
              .confirm(
                transl.title_groupSettings_deleteGroup,
                interpolatedStr,
                {
                  size: 'sm',
                  yes: transl.action_delete,
                  no: transl.action_cancel
                }
              )
              .result.then(function () {
                groupsApiConfig.deleteGroup(groupId).then(
                  function (response) {
                    logger.logSuccess(response.data.messages[0])
                    $location.path(UserService.buildUrl('/settings/groups'))
                  },
                  function (response) {
                    ErrorService.processError(response)
                  }
                )
              })
          },
          function () {
            logger.logError('Unable to load confirm dialog')
          }
        )
    }

    this.$onInit()
  }
})()
